export default "__VITE_ASSET__OWWSSHOO__"